import { defineStore } from 'pinia'
import LayoutStoreInterface from '@/pinia/layout/LayoutStoreInterface'
import { computed, ref, Ref } from 'vue'
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import { notificationSettings, AppConfirmDialog } from 'shared-ritm'
import type { NotificationType } from 'shared-ritm'

// const AppConfirmDialog = defineAsyncComponent(() => import('@/common/app-dialogs/AppConfirmDialog.vue'))

export const useLayoutStore = defineStore('layout-main', (): LayoutStoreInterface => {
  const $q = useQuasar()

  const _logged: Ref<boolean> = ref(false)

  const logged = computed(() => _logged.value)

  const isRootMode = ref(false)

  function setRootMode(value: boolean) {
    isRootMode.value = value
    localStorage.setItem('root', JSON.stringify(value))
    window.dispatchEvent(new CustomEvent('root-mode', { detail: isRootMode.value }))
  }

  function setPending(value: boolean) {
    _logged.value = value
  }

  function notification(type: NotificationType, message: string) {
    //@ts-ignore
    $q.notify(notificationSettings(type, message))
  }

  function confirm(type: 'delete' | 'edit', content: string) {
    return $q.dialog({
      component: AppConfirmDialog,
      componentProps: { content, type },
    })
  }

  return {
    logged,
    isRootMode,
    setPending,
    setRootMode,
    notification,
    confirm,
  }
})
